// extracted by mini-css-extract-plugin
export var downArrow = "_9s-0";
export var infoTooltipIcon = "_9s-3";
export var label = "_9s-1";
export var optionCard = "_9s-4";
export var upArrow = "_9s-2";